import axios from 'axios';
import config from '../config';
import type {
  SupplementalRule,
  SupplementalRulePayload,
  TriggerFeedResponse,
} from '../types/googleSupplemental';

const BASE = `${config.API_URL}/google-supplemental`;

function authHeaders(): { Authorization: string } {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
}

export async function listRules(): Promise<SupplementalRule[]> {
  const { data } = await axios.get<SupplementalRule[]>(`${BASE}/rules`, {
    headers: authHeaders(),
  });
  return data;
}

export async function getRule(id: string): Promise<SupplementalRule> {
  const { data } = await axios.get<SupplementalRule>(`${BASE}/rules/${id}`, {
    headers: authHeaders(),
  });
  return data;
}

export async function createRule(
  payload: SupplementalRulePayload,
): Promise<SupplementalRule> {
  const { data } = await axios.post<SupplementalRule>(
    `${BASE}/rules`,
    payload,
    {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    },
  );
  return data;
}

export async function updateRule(
  id: string,
  payload: Partial<SupplementalRulePayload>,
): Promise<SupplementalRule> {
  const { data } = await axios.put<SupplementalRule>(
    `${BASE}/rules/${id}`,
    payload,
    {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    },
  );
  return data;
}

export async function deleteRule(id: string): Promise<void> {
  await axios.delete(`${BASE}/rules/${id}`, {
    headers: authHeaders(),
  });
}

export async function triggerFeedGeneration(): Promise<TriggerFeedResponse> {
  const { data } = await axios.post<TriggerFeedResponse>(
    `${config.API_URL}/jobs/supplemental-feed`,
    {},
    {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    },
  );
  return data;
}

/** Feed-URL (utan auth) – för att visa användaren var Google kan hämta feeden */
export function getFeedUrl(): string {
  return `${config.API_URL}/google-supplemental/feed`;
}
